import "../scss/style.scss";

import { main as mainCookies } from "./modules/cookies.js";

function main() {
	mainCookies();
}

document.addEventListener("DOMContentLoaded", main);

if (import.meta.hot) {
	import.meta.hot.accept("./main.js", (new_app) => {
		new_app?.main();
	});
}
